import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {groupQuestionsByDriver} from "@irati/insights/helpers/question"

import {QuestionReportingCard} from "../../Question"
import QuestionReportingCardSingleDriver from "../../Question/QuestionReportingCardSingleDriver"

const QuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

class QuestionsList extends Component {
  static propTypes = {
    questions: PropTypes.array,
    drivers: PropTypes.array,
    loading: PropTypes.bool,
    removeFirstDriverGroup: PropTypes.bool
  }
  static defaultProps = {
    questions: [],
    drivers: null,
    loading: false,
    removeFirstDriverGroup: false
  }

  constructor(props) {
    super(props)
    this.idNamespace = id("QuestionsList", props)
    this.idNamespaceQuestionsListWrapper = id("QuestionsListWrapper", this.idNamespace)
  }

  render() {
    const {loading, questions, drivers, removeFirstDriverGroup} = this.props
    const questionsByDriver = groupQuestionsByDriver(questions, drivers, true)
    if (removeFirstDriverGroup) questionsByDriver.shift()

    return (
      <div id={this.idNamespace}>
        <QuestionsWrapper id={this.idNamespaceQuestionsListWrapper}>
          {drivers.length > 1
            ?
            (
              questionsByDriver.map((driverQuestions) => (
                <QuestionReportingCard
                  loading={loading}
                  id={id(driverQuestions.driver.id, this.idNamespace)}
                  key={driverQuestions.driver.id}
                  driverQuestions={driverQuestions} />
              )
              )
            )
            : (
              <QuestionReportingCardSingleDriver id={id("SingleDriver", this.idNamespace)} questions={questions} />
            )
          }
        </QuestionsWrapper>
      </div>
    )
  }
}

export default QuestionsList
